import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Text } from '@/components/shared/components/Text';

export const CartItemErrorAlert = () => {
  return (
    <CustomCartAlert>
      <Text tId={'CART_ALERT_ITEM_ERROR'}></Text>
    </CustomCartAlert>
  );
};
